export default __webpack_public_path__ + "static/media/vouchers_Mob@2x.ed613e78.png";